import { combineReducers } from 'redux';

import account from './account';
import bankCard from './bankCard';
import wallet from './wallet';
import pass from './pass';

function ownReducer(state = null, action) {
  switch (action.type) {
    case 'LOAD_OWN_COMPLETION': {
      const { own, error } = action;

      if (error) {
        return state;
      }

      return own || null;
    }

    case 'RESET_PAY_PASS_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        setPayPass: 1,
      };
    }

    case 'SAVE_BANK_CARD_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        auditIdCard: 1,
      };
    }

    case 'VERIFY_NEW_PHONE_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        username: action.newPhone,
      };
    }

    case 'SAVE_AGENT_INVOICE_PROXY_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        proxyStatus: 0,
      };
    }

    default:
      return state;
  }
}

function loginCodeReducer(state = 0, action) {
  switch (action.type) {
    case 'LOAD_OWN_COMPLETION': {
      const { loginCode, error } = action;

      if (error) {
        return state;
      }

      return loginCode;
    }

    default:
      return state;
  }
}

function shareUidReducer(state = null, action) {
  switch (action.type) {
    case 'SET_SHARE_UID': {
      return action.shareUid || null;
    }

    default:
      return state;
  }
}

export default combineReducers({
  account,
  bankCard,
  wallet,
  pass,
  own: ownReducer,
  loginCode: loginCodeReducer,
  shareUid: shareUidReducer,
});
